import { useTranslation } from 'react-i18next'

import { Alert, Button, ButtonWithSpinner, CardTitle, Drawer, Loading, Text } from '@reveni-io/reveni-ui'

import ImportFileUploader from '@/common/components/ImportFileUploader/ImportFileUploader'
import ProcessSteps from '@/common/components/ProcessSteps'

import { getSteps } from './constants'
import * as Styles from './styles'

const ImportProductValidationDrawer = ({
  onClose,
  show,
  onSelectValidationFile,
  onDeleteValidationFile,
  loading,
  validationFile,
  validationError,
  onError,
  onImport,
  importing,
}) => {
  const { t } = useTranslation()

  return (
    <Drawer show={show} onClose={onClose} size="l" options={{ showHeaderActions: false }}>
      <Loading show={loading} height="350">
        <CardTitle>{t('Importar: Validación de productos')}</CardTitle>
        <Styles.Container>
          <Text>{t('Valida productos devueltos de forma masiva cargando un archivo CSV.')}</Text>
          <ProcessSteps steps={getSteps(t)} />
          <Text type="titleS">{t('Importar CSV')}</Text>
          <ImportFileUploader
            onSelectFile={onSelectValidationFile}
            file={validationFile}
            onDeleteFile={onDeleteValidationFile}
            onError={onError}
          />
          {validationError && <Alert type="error">{t(validationError)}</Alert>}
          <Styles.ActionsContainer>
            <Button onClick={onClose} variant="outlined" fullWidth>
              {t('Cancelar')}
            </Button>
            <ButtonWithSpinner
              fullWidth
              onClick={onImport}
              defaultLabel={t('Importar')}
              loadingLabel={t('Importando')}
              loading={importing}
              disabled={importing || !validationFile}
            />
          </Styles.ActionsContainer>
        </Styles.Container>
      </Loading>
    </Drawer>
  )
}

export default ImportProductValidationDrawer
